import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/styles.css'
import App from './App.tsx'
import { logger } from '@/utils/logger'

// Global error handlers — capture unhandled errors and rejections
const errorCtx = { area: 'global' };

window.onerror = (_message, source, lineno, colno, error) => {
  logger.error(errorCtx, `Unhandled error at ${source}:${lineno}:${colno}`, error ?? undefined);
};

window.onunhandledrejection = (event: PromiseRejectionEvent) => {
  const err = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
  logger.error(errorCtx, 'Unhandled promise rejection', err);
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
